import { useEffect } from "react";

import { WeezSocket } from "@weezevent/piglet";

export const useWeezSocket = (callback) => {
  useEffect(
    () => WeezSocket.register(callback),
    [callback],
  );
};
